import {retry} from '@rambler-id/promise'

export const afisha = retry<any>(() => import('./afisha'))
export const classic = retry<any>(() => import('./classic'))
export const eda = retry<any>(() => import('./eda'))
export const lenta = retry<any>(() => import('./lenta'))
export const universal = retry<any>(() => import('./universal'))

// map skin names to eagle values
export {afisha as suggest_afisha, lenta as suggest_lenta, eda as suggest_eda}
